import { findTripCall, formatGtfsStartDate } from "./liveTripTiming";
import { assembleDateTime, getNextStop } from "./tripMapTiming";

const NEXT_STOP_PAST_GRACE_MS = 4_000;

function toNextStopResult(stop, currentStatus = null) {
  if (!stop) {
    return null;
  }

  return {
    stopId: stop.stop_id,
    stopName: stop.stop_name,
    stopType: stop.stop_type || null,
    currentStatus,
  };
}

export function getTripMapNextStopDetails(
  startDate,
  stops,
  stopTimeUpdate,
  currentStatus = null,
  delaySeconds = 0,
  now = Date.now(),
) {
  const { index: liveStopIndex } = findTripCall(stops, stopTimeUpdate);

  if (liveStopIndex >= 0) {
    const liveStop = stops[liveStopIndex];

    if (
      currentStatus === "INCOMING_AT" ||
      currentStatus === "STOPPED_AT" ||
      !liveStop
    ) {
      return {
        stopOrder: liveStopIndex,
        stopId: stops[liveStopIndex].stop_id,
        stopName: stops[liveStopIndex].stop_name,
      };
    }

    const liveStopEventEpochSeconds = Number(
      stopTimeUpdate?.departure?.time ?? stopTimeUpdate?.arrival?.time,
    );
    const liveStopAdjustedTime = Number.isFinite(liveStopEventEpochSeconds)
      ? liveStopEventEpochSeconds * 1000
      : startDate && liveStop?.departure_time
        ? assembleDateTime(startDate, liveStop.departure_time) +
          (Number(delaySeconds) || 0) * 1000
        : null;

    if (
      Number.isFinite(liveStopAdjustedTime) &&
      Number(now) > liveStopAdjustedTime + NEXT_STOP_PAST_GRACE_MS &&
      liveStopIndex < stops.length - 1
    ) {
      return {
        stopOrder: liveStopIndex + 1,
        stopId: stops[liveStopIndex + 1].stop_id,
        stopName: stops[liveStopIndex + 1].stop_name,
      };
    }

    return {
      stopOrder: liveStopIndex,
      stopId: liveStop.stop_id,
      stopName: liveStop.stop_name,
    };
  }

  return getNextStop(
    startDate,
    Array.isArray(stops) ? stops : [],
    Number(now),
    Number(delaySeconds) || 0,
  );
}

export function getVehicleNextStop(vehicleUpdate, stops, now = Date.now()) {
  const update = vehicleUpdate?.update;
  const stopTimeUpdate = Array.isArray(update?.stopTimeUpdate)
    ? update.stopTimeUpdate[0]
    : null;
  const nextStopDetails = getTripMapNextStopDetails(
    formatGtfsStartDate(vehicleUpdate?.trip?.startDate),
    stops,
    stopTimeUpdate,
    update?.currentStatus || null,
    stopTimeUpdate?.arrival?.delay,
    now,
  );

  if (nextStopDetails?.stopId) {
    return toNextStopResult(
      stops?.[Math.min(nextStopDetails.stopOrder, stops.length - 1)],
      update?.currentStatus || null,
    );
  }

  const startDate = formatGtfsStartDate(vehicleUpdate?.trip?.startDate);
  const delaySeconds = Number(stopTimeUpdate?.arrival?.delay) || 0;
  const scheduledNextStop =
    startDate && Array.isArray(stops)
      ? getNextStop(startDate, stops, Number(now), delaySeconds)
      : null;
  const scheduledStopIndex = Number.isInteger(scheduledNextStop?.stopOrder)
    ? Math.min(scheduledNextStop.stopOrder, stops.length - 1)
    : -1;

  if (scheduledStopIndex >= 0) {
    return toNextStopResult(
      stops[scheduledStopIndex],
      update?.currentStatus || null,
    );
  }

  const { index: vehiclePositionStopIndex } = findTripCall(stops, update);

  if (vehiclePositionStopIndex < 0) {
    return null;
  }

  return toNextStopResult(
    stops[vehiclePositionStopIndex],
    update?.currentStatus || null,
  );
}
